import styled from 'styled-components';

const InfoCardsWrapper = styled.div`
  display: flex;
  gap: 16px;
`;

const Row = styled.div`
  display: flex;
  flex-direction: row;
  gap: 24px;
`;

const SpeedArea = styled.div`
  align-items: center;
  display: flex;
  gap: 16px;
  justify-content: space-between;
`;

const IconWrapper = styled.div`
  align-items: center;
  background: var(--color-bg-weak);
  border-radius: var(--radius-full);
  display: flex;
  height: 40px;
  justify-content: center;
  width: 40px;
`;

const CardHeader = styled.div`
  align-items: center;
  display: flex;
  gap: 8px;
`;

export { CardHeader, IconWrapper, InfoCardsWrapper, Row, SpeedArea };
